import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";

import AdminLayout from "../../../../layouts/admin/AdminLayout";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/admin/dashboardcss/AdminNotifications.css";

export default function AllNotifications() {
  const { baseUrl } = useContext(AppContext);
  const [notifications, setNotifications] = useState([]);
  const outletCtx = useOutletContext?.() || {};

  const viewAllNotifications = () => {
    axios
      .get(`${baseUrl}/admin/notifications/viewAllNotifications`)
      .then((response) => setNotifications(response.data.notifications))
      .catch((error) => console.log(error));
  };

  const markAllRead = () => {
    axios
      .post(`${baseUrl}/admin/notifications/markAllRead`)
      .then(() => {
        viewAllNotifications();
        outletCtx.refreshNotificationCount?.();
      })
      .catch((error) => console.log(error));
  };

  const markAsRead = (id) => {
    axios
      .post(`${baseUrl}/admin/notifications/updateNotification`, { id })
      .then(() => {
        viewAllNotifications();
        outletCtx.refreshNotificationCount?.();
      })
      .catch((error) => console.log(error));
  };

  const deleteNotification = (id) => {
    axios
      .post(`${baseUrl}/admin/notifications/deleteNotification`, { id })
      .then(() => {
        viewAllNotifications();
        outletCtx.refreshNotificationCount?.();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewAllNotifications();
  }, []);

  return (
    <AdminLayout>
      <div className="sgc-an-wrapper">
        <div className="sgc-an-page-header">
          <div>
            <h1 className="sgc-an-page-title">All Notifications</h1>
            <p className="sgc-an-page-sub">Stay updated with your clinic activity</p>
          </div>
          <button className="sgc-an-mark-btn" onClick={markAllRead}>
            Mark all as read
          </button>
        </div>

        <div className="sgc-an-card">
          <ul className="sgc-an-list">
            {notifications.map((n) => (
              <li
                key={n.id}
                className={`sgc-an-item ${n.is_read === 0 ? "sgc-an-item--unread" : ""}`}
                onClick={() => n.is_read === 0 && markAsRead(n.id)}
                style={{ cursor: "pointer" }}
              >
                <div className="sgc-an-icon">🔔</div>

                <div className="sgc-an-content">
                  <div className="sgc-an-top-row">
                    <p className="sgc-an-title">{n.title}</p>
                    <span className="sgc-an-category-tag">{n.for}</span>
                  </div>
                  <p className="sgc-an-desc">{n.description}</p>
                </div>

                {n.is_read === 0 && <span className="sgc-an-dot" />}

                <button
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteNotification(n.id);
                  }}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </AdminLayout>
  );
}